// extracted by mini-css-extract-plugin
export default {"sideNav":"sideNav_sideNav__yVFC+","logo":"sideNav_logo__Y3XmM","collapsed":"sideNav_collapsed__7Bn8V"};